import { LOCALE_IDS, type LocaleId } from '@bannermatic/core';
import { HUB_PATHS, PAGE_PATHS } from './content/shared';
import {
  categoryPath,
  PUBLIC_CATEGORIES,
  PUBLIC_SIZES,
  PUBLIC_TEMPLATES,
  SIZES_PATH,
  sizePath,
  TEMPLATES_PATH,
  templatePath,
} from './programmatic';

/**
 * Public pages that are pre-rendered for search engines: unprefixed path → languages the page
 * exists in. Plain data (no components) so the language detection can read it at start-up.
 */
export const PUBLIC_PATHS: Record<string, readonly LocaleId[]> = {
  '/': LOCALE_IDS,
  '/privacy': LOCALE_IDS,
  '/terms': LOCALE_IDS,
  '/contact': LOCALE_IDS,
  ...Object.fromEntries(
    [
      ...Object.values(HUB_PATHS),
      ...Object.values(PAGE_PATHS),
      TEMPLATES_PATH,
      ...PUBLIC_CATEGORIES.map(categoryPath),
      ...PUBLIC_TEMPLATES.map(templatePath),
      SIZES_PATH,
      ...PUBLIC_SIZES.map(sizePath),
    ].map((p) => [p, LOCALE_IDS]),
  ),
};

export function publicPageLocales(path: string): readonly LocaleId[] | null {
  return PUBLIC_PATHS[path] ?? null;
}
